<template>
  <h1 class="text-3xl pt-6 mb-9 font-mono"><slot /></h1>
</template>
